var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkBlueFolder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 69,
    viewBox: "0 0 70 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_769_3013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.3349 11.5928H61.1699L65.3349 22.0053H69.4998V15.7578C69.4998 13.4671 67.6256 11.5928 65.3349 11.5928Z",
    fill: "#100A3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1699 11.5928H26.6699V22.0053H65.3349V15.7578C65.335 13.4671 63.4607 11.5928 61.1699 11.5928Z",
    fill: "#221A59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3349 53.2422L61.1699 63.6547H65.3349C67.6256 63.6547 69.4998 61.7805 69.4998 59.4898V57.4073L65.3349 53.2422Z",
    fill: "#221A59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3351 59.4897V53.2422L0.5 57.4071V59.4897C0.5 61.7804 2.37419 63.6546 4.66493 63.6546H61.17C63.4607 63.6546 65.3351 61.7804 65.3351 59.4897Z",
    fill: "#221A59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3349 17.8398H61.1699L65.3349 57.4073H69.4998V22.0049C69.4998 19.7142 67.6256 17.8398 65.3349 17.8398Z",
    fill: "#221A59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3351 22.0046C65.3351 19.7138 63.4609 17.8397 61.1701 17.8397H39.1649L33.1452 8.81009C31.8747 6.90423 28.9606 5.34473 26.6699 5.34473H4.66493C2.37419 5.34459 0.5 7.21878 0.5 9.50952V57.407H65.3351V22.0046Z",
    fill: "#3A3275"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_769_3013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 69,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkBlueFolder);
export default __webpack_public_path__ + "static/media/dark-blue-folder.27f5b9cdbcbc8b265e961faa948c1116.svg";
export { ForwardRef as ReactComponent };